import { createGlobalStyle } from 'styled-components';
const GlobalStyle = createGlobalStyle`
  :root {
    --sfondo: ${p => (p.theme as any)?.sfondo || '#f1f4f9'};
  }

  *, *::before, *::after {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    background: var(--sfondo);
    font-family: Rubik, Segoe UI, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html, body {
    height: 100%;
  }

  #root {
    height: 100%;
    display: flex;
    flex-direction: column;
    -webkit-transform: translate3d(0, 0, 0);
    /* Kill iOS tap delay / double-tap heuristics on the whole app subtree so
       taps register on the first press (touch-action intersects down the tree). */
    touch-action: manipulation;
  }

  input {
    font-family: Rubik, Segoe UI, sans-serif;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance: textfield; /* Firefox */
  }

  button {
    font-family: Rubik, Segoe UI, sans-serif;
  }

  h1, h2, h3, h4, h5, h6, p {
    margin: 0;
  }
`;

export default GlobalStyle;
